
<app-header-component></app-header-component>
<div class="p-4 flex flex-col all-sessions-container">
  <div class="mb-4 flex flex-row items-center gap-4 toolbar">
    <h2 class="text-2xl mr-4">Sessions d'éligibilité</h2>
    <mat-checkbox [(ngModel)]="displayedArchived" (change)="getSessions()">Afficher les sessions archivées</mat-checkbox>
    <div class="spacer"></div>
    <mat-form-field subscriptSizing="dynamic" class="content-size">
      <mat-label>Ouvrir une session existante</mat-label>
        <input 
          matInput 
          type="text" 
          placeholder="Code session"
          [(ngModel)]="sessionCode"
          (keydown.enter)="checkSessionCodeThenOpenSession()">
        <button 
          matSuffix 
          matIconButton 
          class="ml-2"
          aria-label="Clear" 
          [matTooltip]="'Effacer'"
          [disabled]="sessionCode() === ''" 
          (click)="clearSessionCode()">
          <mat-icon>close</mat-icon>
        </button>
        @if (isSessionCodeLoading()) {
          <button 
            class="mr-2" 
            matSuffix
            matIconButton
            [disabled]="true">
            <mat-icon class="fas fa-spinner fa-pulse"></mat-icon>
          </button>
        } @else {
          <button 
            class="mr-2" 
            matSuffix 
            matIconButton 
            [matTooltip]="'Ouvrir la session'"
            [disabled]="!sessionCodeExists()" 
            (click)="openSession(sessionCode())">
            <mat-icon>open_in_new</mat-icon>
          </button>
        }
    </mat-form-field>
    
    <button class="content-size" mat-stroked-button (click)="createSession()">Créer une nouvelle session</button>   
  </div>
  <ag-grid-angular
    class="grid-dimensions"
    [localeText]="gridLocale"
    [columnDefs]="columns"
    [rowData]="sessions()"
    [loadingOverlayComponent]="loadingOverlayComponent"
    [loadingOverlayComponentParams]="loadingOverlayComponentParams"
    [getRowId]="getRowId"
    [rowClass]="'h-full flex items-center'"
    [autoSizeStrategy]="{type: 'fitGridWidth'}"
    [animateRows]="false"
    (gridReady)="onGridReady($event)"
    (rowDoubleClicked)="openSession($event.data.code)"
    />
</div>
